import ajax from '@/utils/ajax';

// 保存用户购课信息
export const reqBilibiliOrderSave = (requestBody) => (ajax('/web/v1/bilibili-order/save', requestBody, 'POST'));

// 编辑用户购课信息
export const reqBilibiliOrderEdit = (requestBody) => (ajax('/web/v1/bilibili-order/edit', requestBody, 'PUT'));

// 检查是否填写（英语）购课信息
export const reqBilibiliOrderCheck = (id) => (ajax(`/web/v1/bilibili-order/check-order?bProductId=${id}`));

// 根据b站订单号查询订单购课信息详情
export const reqBilibiliOrderDetail = (bOrderNo, bproductId) => (ajax(`/web/v1/bilibili-order/detail?bOrderNo=${bOrderNo}&bProductId=${bproductId}`));

// 获取购课订单信息列表
export const reqBilibiliOrderList = (verifyCode, phone) => (ajax(`/web/v1/bilibili-order/list?verifyCode=${verifyCode}&phone=${phone}`));

// 验证验证码
export const reqBilibiliOrderValidateCode = ({ type, code, phone }) => (ajax(`/web/v1/bilibili-order/validate-code?type=${type}&code=${code}&phone=${phone}`, {}, 'POST'));

// 根据b站订单号查询订单发货信息
export const reqBilibiliOrdereliverDetail = (bOrderNo) => (ajax(`/web/v1/bilibili-order/deliver-detail?bOrderNo=${bOrderNo}`));

// 修改收货地址
export const editOrderAddress = (requestBody) => (ajax('/web/v1/bilibili-order/edit-address', requestBody, 'PUT'));
